import React from 'react';
import HelpContent from './../HelpContent';

const EscenarioCN1Help = () => (
  <HelpContent>
    <h1>
        Escenario Carbono Neutralidad 1 (CN1)
    </h1>
    <p> Este escenario proyecta las emisiones a nivel nacional considerando la implementación de las principales medidas de mitigación propuestas en el NDC del año 2025 
      (retiro de centrales a carbón, electromovididad, introducción de hidroógeno verde, electrificación de usos finales en el sector residencial, etc.).
    </p>
      
    <p> Los resultados de este escenario cumplen con la meta de carbono neutralidad 2050. Las trayectorias o niveles de implementación de las medidas se construyen en base 
      a la información entregada por los Planes Sectoriales de Mitigación y Adaptación al Cambio Climático (PSM), con documentación de otras estrategias, comisiones y otras fuentes de información relevantes.

    </p>

  
  </HelpContent>
);

export default EscenarioCN1Help;
